export default "<div class=\"fieldset-content\" fxLayout=\"column\">\n  <ng-content></ng-content>\n</div>\n";